// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".c-v-button__spinner-wrapper[data-v-57d95c57]{display:inline-block!important}.c-v-button__spinner-wrapper.has-label[data-v-57d95c57]{margin-right:10px!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
